<nz-modal [(nzVisible)]="isVisible" [nzTitle]="'POC Details'" [nzWidth]="990" (nzOnCancel)="handleCancel()" [nzFooter]="footerTpl" >

  <ng-container *nzModalContent>

    <nz-table #basicTable [nzData]="poc_details" [nzBordered]="false" [nzSize]="'small'" [nzShowPagination]="'false'">
      <thead>
        <tr>
          <!-- <th>Client</th> -->
          <th>Type</th>
          <th>Name</th>
          <th>Email</th>
          <th>Job Title</th>
          <th>Linkedin</th>
          <th>Phone</th>
          <th *ngIf="showActions">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let poc of poc_details">
          <td>
            <ng-container *ngIf="poc?.type_name === 'Primary'; else setPrimaryPOC;">
               <nz-tag [nzColor]="'#87d068'">{{poc?.type_name}}</nz-tag>

            </ng-container>
            <ng-template #setPrimaryPOC>
             <nz-tag  nzMode="checkable"
              (nzCheckedChange)="setPrimaryPOCDetail($event, poc)">
              Set Primary
             </nz-tag>
            </ng-template>
          </td>
          <td>{{poc?.poc_name}}</td>
          <td>{{poc?.poc_email}}</td>
          <td nz-tooltip [nzTooltipTitle]="poc?.job_title">{{truncateText(poc?.job_title, 5)}}</td>
          <td>
             <a *ngIf="poc?.poc_linkedin" [href]="poc?.poc_linkedin" target="_blank">
              <nz-icon nzType="linkedin" nzTheme="fill" style="font-size: 20px;" />
              </a>
              <span *ngIf="!poc?.poc_linkedin">N/A</span>
          </td>
          <td>{{poc?.country_code_details?.code}} {{poc?.poc_phone}}</td>
          <td *ngIf="showActions">
            <button nz-button nzType="text" nzSize="small" style="margin-left: 8px;"
            nz-tooltip [nzTooltipTitle]="'Edit'"  nzTooltipPlacement="top"
            ><nz-icon nzType="edit" nzTheme="outline" (click)="editPOC(poc)" /></button>


            <button 
            nz-button nzType="text" nzDanger nzSize="small" style="margin-left: 8px;"
            nz-tooltip [nzTooltipTitle]="'Delete'"  nzTooltipPlacement="top"
            [nz-popconfirm]="deletePOCPopconfirm"
            [nzPopconfirmTitle]="''"
            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            nzPopconfirmPlacement="bottom"
            (nzOnConfirm)="deletePOC(poc)"
            ><nz-icon nzType="delete" nzTheme="outline" /></button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>

  <ng-template #footerTpl>
    <div >

      <button nz-button nzType="primary" (click)="handleOk()" > OK</button>
    </div>
  </ng-template>
</nz-modal>

<ng-template #deletePOCPopconfirm>
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this POC?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
</ng-template>
